<template>
  <div class="silder-contain slider-posterActivitiesManage" :class="aciveInfo.aciveClass">
    <div class="slider-top clearFloat">
      <p class="h3 slider-title pull-left">{{aciveInfo.aciveText}}</p>
      <div class="pull-right h1 btn-close font-gray" @click="hideSliderBox">
        <i class="el-icon-close"></i>
      </div>
      <el-button
        type="primary"
        v-if="!isEdit"
        class="pull-right"
        @click="onSubmit"
      >{{$t('posterActive.confirmPublish')}}</el-button>
      <el-button
        type="primary"
        v-else
        class="pull-right"
        @click="onSubmit"
      >{{$t('posterActive.confirmEdit')}}</el-button>
    </div>
    <div class="slider-cont text-1">
      <el-form ref="form" :model="form" :rules="rules" label-width="130px">
        <el-form-item :label="$t('posterActive.item_text1')" prop="activity_name">
          <el-input
            v-model="form.activity_name"
            style="width: 400px;"
            :placeholder="$t('posterActive.form_phoder1')"
          ></el-input>
          <!-- <span class="tip-text">
            <i class="tip-icon">!</i>
            {{$t('posterActive.nameOnly')}}
          </span>-->
        </el-form-item>
        <el-form-item :label="$t('posterActive.item_text2')" prop="activity_theme">
          <el-input
            v-model="form.activity_theme"
            style="width: 400px;"
            :placeholder="$t('posterActive.form_phoder2')"
          ></el-input>
        </el-form-item>
        <div class="active-time">
          <el-form-item :label="$t('posterActive.item_text3')" prop="times">
            <el-date-picker
              v-model="form.times"
              style="width: 400px;"
              type="datetimerange"
              :range-separator="$t('Common.to')"
              :start-placeholder="$t('posterActive.form_phoder3_1')"
              :end-placeholder="$t('posterActive.form_phoder3_3')"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="pickerOptions"
              @change="timesChange"
            ></el-date-picker>
          </el-form-item>
          <!-- <span class="tip-text">
            <i class="tip-icon">!</i>
            {{$t('posterActive.activeEnd')}}
          </span>-->
        </div>
        <el-form-item :label="$t('posterActive.item_text4')" prop="frommedia_name">
          <el-select
            @change="frommediaSearch"
            v-model="form.frommedia_name"
            style="width: 400px;"
            :placeholder="$t('posterActive.form_phoder4')"
          >
            <el-option
              v-for="item in SourceList"
              :key="item.frommedia_id"
              :label="item.frommedia_name"
              :value="item.frommedia_name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('posterActive.item_text5')" prop="channel_id">
          <el-select
            v-model="form.channel_id"
            style="width: 400px;"
            :placeholder="$t('posterActive.form_phoder5')"
          >
            <el-option
              v-for="item in ChannelList"
              :key="item.channel_id"
              :label="item.channel_name"
              :value="item.channel_id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('posterActive.item_text6')">
          <div class="uplode-div active-upload">
            <el-upload
              class="avatar-uploader"
              :action="$uploadAction('/Uploading/Picture')"
              name="ossfile"
              :data="Uploadeimg"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <img v-if="imageUrl" :src="imageUrl" class="avatar" />
              <div v-else>
                <i class="el-icon-plus"></i>
                <div class="el-upload__text">{{$t('posterActive.form_phoder6')}}</div>
              </div>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item :label="$t('posterActive.item_text10')">
          <div class="uplode-div active-upload">
            <el-upload
              class="avatar-uploader"
              :action="$uploadAction('/Uploading/Picture')"
              name="ossfile"
              :data="UploadeimgThree"
              :show-file-list="false"
              :on-success="handleAvatarSuccessThree"
              :before-upload="beforeAvatarUpload"
            >
              <img v-if="imageUrlThree" :src="imageUrlThree" class="avatar" />
              <div v-else>
                <i class="el-icon-plus"></i>
                <div class="el-upload__text">{{$t('posterActive.form_phoder10')}}</div>
              </div>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item :label="$t('posterActive.item_text7')" class="poster-temp">
          <el-radio-group v-model="form.activitytemp_id">
            <el-radio-button
              v-for="(item,index) in ActivitytempOption"
              :key="index"
              :label="item.activitytemp_id"
            >
              <img :src="item.activitytemp_styleimg" @click="perviewTemp(item)" alt />
            </el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('posterActive.item_text11')">
          <el-input
            type="textarea"
            v-model="form.activity_content"
            style="width: 400px;"
            :placeholder="$t('posterActive.form_phoder11')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('posterActive.item_text8')">
          <el-input
            type="textarea"
            v-model="form.activity_sharedesc"
            style="width: 400px;"
            :placeholder="$t('posterActive.form_phoder8')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('posterActive.item_text9')" class="upload-share">
          <el-upload
            class="avatar-share-img"
            :action="$uploadAction('/Uploading/Picture')"
            name="ossfile"
            :data="UploadeimgTwo"
            :show-file-list="false"
            :on-success="handleAvatarSuccessTwo"
            :before-upload="beforeAvatarUpload"
          >
            <img v-if="imageUrlTwo" :src="imageUrlTwo" class="avatar" />
            <div v-else class="share-text">
              <i class="el-icon-plus"></i>
              <div class="el-upload__text">{{$t('posterActive.form_phoder9')}}</div>
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
// 1、引入VueUeditorWrap组件
// import VueNeditorWrap from "vue-neditor-wrap";
import storeActive from "./active.js";
export default {
  name: "active",
  props: ["aciveInfo", "showSliderBox", "isEdit", "infomationData"],
  data() {
    return {
      // 侧边栏 海报活动生成
      form: {
        activity_name: "", //活动名称
        activity_pattern: 2, //招生活动模式：0普招模式1验券模式 2海报活动
        activity_theme: "", //活动主题
        activity_imgwidth: "750", // 主图宽
        activity_imgheight: "320", //主图高
        times: "", //时间
        activity_starttime: "", //开始时间
        activity_endtime: "", //结束时间
        activity_istemp: 1, //是否使用招生模板
        activitytemp_id: "", //招生模板id
        activity_tempurl: "", //自定义招生模板链接
        activity_contacttel: "", //联系方式
        activity_address: "", //活动地址
        activity_demoimg: "", //海报封面图
        activity_img: "", //主图
        activity_content: "", //活动详情
        activity_rule: "", //活动规则
        activity_sharedesc: "", //分享描述
        activity_shareimg: "", //分享小图片
        activity_aboutus: "", //关于我们
        activity_customcontent: "", //自定义详情
        frommedia_name: "", //来源聚道类型
        channel_id: "", //招生渠道明细
      },
      imageUrl: "", //上传海报封面图
      Uploadeimg: {
        company_id: "",
        ossfile: "",
      },
      imageUrlTwo: "", //上传分享图
      UploadeimgTwo: {
        company_id: "",
        ossfile: "",
      },
      imageUrlThree: "", //上传海报主图
      UploadeimgThree: {
        company_id: "",
        ossfile: "",
      },
      ActivitytempOption: [], //模板
      SourceList: [], //招生渠道类型
      ChannelList: [], //招生渠道明细
      ActivitytempOne: {}, //单个模板信息
      pickerOptions: {
        disabledDate: (time) => {
          (() => {})(time, 1133);
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      pickerOptionsStartCreate: {
        disabledDate: (time) => {
          if (this.form.activity_endtime && !this.isEdit) {
            return (
              time.getTime() < new Date(this.form.activity_endtime).getTime()
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      pickerOptionsEndCreate: {
        disabledDate: (time) => {
          if (this.form.activity_starttime && !this.isEdit) {
            return (
              time.getTime() < Date.now() - 8.64e7 ||
              time.getTime() < new Date(this.form.activity_starttime).getTime()
            );
          } else {
            if (this.isEdit) {
              return (
                time.getTime() < Date.now() - 8.64e7 ||
                time.getTime() <
                  new Date(this.form.activity_starttime).getTime()
              );
            } else {
              return (
                time.getTime() > Date.now() - 8.64e7 ||
                time.getTime() >
                  new Date(this.form.activity_starttime).getTime()
              );
            }
          }
        },
      },
      // 表单验证
      rules: {
        activity_name: [
          {
            required: true,
            message: this.$t("posterActive.rule_tips3"),
            trigger: "blur",
          },
          {
            min: 2,
            max: 50,
            message: this.$t("posterActive.rule_tips4"),
            trigger: "blur",
          },
        ],
        activity_pattern: [
          {
            required: true,
            message: this.$t("posterActive.rule_tips5"),
            trigger: "change",
          },
        ],
        times: [
          {
            required: true,
            message: this.$t("posterActive.rule_tips6"),
            trigger: "change",
          },
        ],
        activity_theme: [
          {
            required: true,
            message: this.$t("posterActive.rule_tips7"),
            trigger: "blur",
          },
        ],
        activity_endtime: [
          {
            required: true,
            message: this.$t("posterActive.rule_tips8"),
            trigger: "change",
          },
        ],
        frommedia_name: [
          {
            required: true,
            message: this.$t("posterActive.rule_tips9"),
            trigger: "change",
          },
        ],
        channel_id: [
          {
            required: true,
            message: this.$t("posterActive.rule_tips10"),
            trigger: "change",
          },
        ],
        // activity_contacttel: [
        //   {
        //     required: true,
        //     message: this.$t('posterActive.rule_tips11'),
        //     trigger: "blur"
        //   }
        // ]
        // activity_contacttel: [{ validator: checkPhone, trigger: "blur" }]
      },
    };
  },
  components: {},
  created() {
    this.token = this.$store.state.USER_TOKEN;
    this.marketer_id = this.$store.state.MARKETER_ID;
    this.school_id = this.$store.state.SCHOOL_ID;
    this.company_id = this.$store.state.COMPANY_ID;
    this.Uploadeimg.company_id = this.company_id;
    this.UploadeimgTwo.company_id = this.company_id;
    this.UploadeimgThree.company_id = this.company_id;
    this.ActivitytempApi();
    this.getSourceApi(); // 获取渠道类型
    this.getChannelApi(); // 获取渠道明细
    //   编辑
    this.showInformation(); // 显示编辑的信息
  },
  watch: {
    getshowSliderBox(n, o) {
      (() => {})(n, o);
      if (!n) {
        // 清空数据
        this.resetForm();
      } else {
        this.showInformation(); // 显示编辑的信息
      }
    },
  },
  computed: {
    getshowSliderBox() {
      return this.showSliderBox;
    },
    companyIsmajor() {
      return this.$store.state.companyIsmajor; //0是免费版 1是普通版   2是专业版
    },
  },
  methods: {
    // 招生目标->活动招生模板管理
    ActivitytempApi() {
      storeActive
        .ActivitytempApi({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
          activitytemp_class: 1, //海报活动
        })
        .then((res) => {
          this.ActivitytempOption = res.data.data.data;
          if (!this.isEdit && this.ActivitytempOption.length > 0) {
            this.form.activitytemp_id = this.ActivitytempOption[0].activitytemp_id;
            // this.ActivitytempOneApi();
          }
        });
    },
    //招生目标->单个招生模板的信息************
    ActivitytempOneApi() {
      storeActive
        .ActivitytempOneApi({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
          activitytemp_id: this.form.activitytemp_id,
        })
        .then((res) => {
          this.ActivitytempOne = res.data.data.data;
        });
    },
    // 获取渠道类型
    getSourceApi() {
      this.$http
        .getSourceApi({
          staffer_id: this.staffer_id,
          company_id: this.company_id,
          token: this.token,
        })
        .then((res) => {
          this.SourceList = res.data.data.list;
        });
    },
    // 获取渠道明细
    getChannelApi() {
      this.$http
        .getChannelApi({
          staffer_id: this.staffer_id,
          company_id: this.company_id,
          token: this.token,
          channel_medianame: this.form.frommedia_name,
        })
        .then((res) => {
          this.ChannelList = res.data.data.list;
        });
    },
    // 选择活动时间
    timesChange() {
      (() => {})(this.form.times);
      if (this.form.times) {
        if (this.form.times[0] === this.form.times[1]) {
          this.form.times = "";
          this.$message({
            message: this.$t("active.rule_tips12"),
            type: "error",
          });
        } else {
          this.form.activity_starttime = this.form.times[0];
          this.form.activity_endtime = this.form.times[1];
        }
      } else {
        this.$set(this.form,'times',[])
        this.form.activity_starttime = "";
        this.form.activity_endtime = "";
      }
    },
    // 选择系统模板
    activitytempChange() {
      this.ActivitytempOneApi();
    },
    hideSliderBox() {
      this.$emit("hideSliderBox");
    },
    // 预览模版
    perviewTemp(item) {
      this.ActivitytempOne = item;
      this.$emit("perviewTemp", this.ActivitytempOne);
    },
    // 查看预览图
    perviewSeeTemp() {
      (() => {})(this.ActivitytempOne, this.infomationData);
      this.$emit("perviewSeeTemp", this.ActivitytempOne);
    },
    // 显示编辑的信息
    showInformation() {
      this.activeName = "first"; //初始化
      //   编辑
      if (this.isEdit) {
        let value = this.infomationData;
        this.ActivitytempOne = this.infomationData;
        this.form = {
          activity_name: value.activity_name, //活动名称
          activity_theme: value.activity_theme, //活动主题
          activity_imgwidth: value.activity_imgwidth, // 主图宽
          activity_imgheight: value.activity_imgheight, //主图高
          activity_pattern: parseInt(value.activity_pattern), //活动类型
          activity_starttime: value.activity_starttime, //开始时间
          activity_endtime: value.activity_endtime, //结束时间
          activity_istemp: parseInt(value.activity_istemp), //是否使用招生模板
          activitytemp_id: value.activitytemp_id, //招生模板id
          activity_tempurl: value.activity_tempurl, //自定义招生模板链接
          activity_contacttel: value.activity_contacttel, //联系方式
          activity_address: value.activity_address, //活动地址
          activity_demoimg: value.activity_demoimg, //海报封面图
          activity_img: value.activity_img, //主图
          activity_content: !value.activity_content
            ? ""
            : value.activity_content, //活动详情
          activity_rule: value.activity_rule, //活动规则
          activity_sharedesc: value.activity_sharedesc, //分享描述
          activity_shareimg: value.activity_shareimg, //分享小图片
          activity_aboutus: !value.activity_aboutus
            ? ""
            : value.activity_aboutus, //关于我们
          activity_customcontent: !value.activity_customcontent
            ? ""
            : value.activity_customcontent, //自定义详情
          frommedia_name: value.frommedia_name, //来源聚道名称
          channel_id: value.channel_id, //招生渠道明细
        };
        this.form.times = [value.activity_starttime, value.activity_endtime];
        this.form = JSON.parse(JSON.stringify(this.form))
        this.imageUrl = value.activity_demoimg;
        this.imageUrlThree = value.activity_img;
        this.imageUrlTwo = value.activity_shareimg;
      } else {
        this.resetForm();
      }
    },
    // 表单清空
    resetForm() {
      // 清空数据
      this.form = {
        activity_name: "", //活动名称
        activity_theme: "", //活动主题
        activity_imgwidth: "750", // 主图宽
        activity_imgheight: "320", //主图高
        activity_pattern: 2, //活动类型 招生活动模式：0普招模式1验券模式 2海报活动
        range_time: "", //时间范围
        activity_starttime: "", //开始时间
        activity_endtime: "", //结束时间
        activity_istemp: 1, //是否使用招生模板
        activitytemp_id: "", //招生模板id
        activity_tempurl: "", //自定义招生模板链接
        activity_contacttel: "", //联系方式
        activity_address: "", //活动地址
        activity_demoimg: "", //海报封面图
        activity_img: "", //主图
        activity_content: "", //活动详情
        activity_rule: "", //活动规则
        activity_sharedesc: "", //分享描述
        activity_shareimg: "", //分享小图片
        activity_aboutus: "", //关于我们
        activity_customcontent: "", //自定义详情
        frommedia_name: "", //招生渠道类型
        channel_id: "", //招生渠道明细
      };
      this.imageUrl = "";
      this.imageUrlThree = "";
      this.imageUrlTwo = "";
      if (this.$refs["form"]) {
        this.$refs["form"].resetFields();
      }
    },
    // 招生渠道类型筛选
    frommediaSearch() {
      this.form.channel_id = "";
      this.getChannelApi(); // 获取渠道明细
    },
    // 选择模板
    selcetTemp() {
      this.form.activity_tempurl = "";
      if (!this.isEdit && this.ActivitytempOption.length > 0) {
        this.form.activitytemp_id = this.ActivitytempOption[0].activitytemp_id;
      } else if (this.isEdit) {
        this.form.activitytemp_id = this.infomationData.activitytemp_id;
        this.form.activity_tempurl = this.infomationData.activity_tempurl;
      }
    },
    loadUeditor(p) {
      (() => {})(p);
    },
    // 确定发布
    onSubmit() {
      let data = this.form;
      data["marketer_id"] = this.marketer_id;
      data["token"] = this.token;
      data["school_id"] = this.school_id;
      data["company_id"] = this.company_id;
      if (this.form.activity_istemp == "0") {
        this.form.activitytemp_id = "";
      }
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.$emit("onSubmit", data);
        } else {
          (() => {})("error submit!!");
          return false;
        }
      });
    },
    // 切换选项卡
    handleClick(tab, event) {
      (() => {})(tab, event);
    },
    //上传海报封面图
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
      if (res.code === 200) {
        this.form.activity_demoimg = res.data.picture_imgurl;
      }
      (() => {})(res);
    },
    // 上传海报主图
    handleAvatarSuccessThree(res, file) {
      this.imageUrlThree = URL.createObjectURL(file.raw);
      if (res.code === 200) {
        this.form.activity_img = res.data.picture_imgurl;
      }
      (() => {})(res);
    },
    // 上传分享图
    handleAvatarSuccessTwo(res, file) {
      this.imageUrlTwo = URL.createObjectURL(file.raw);
      if (res.code === 200) {
        this.form.activity_shareimg = res.data.picture_imgurl;
      }
      (() => {})(res);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isGIF = file.type === "image/gif";
      const isImg = isJPG || isPNG || isGIF;
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPNG && !isGIF) {
        this.$message.error("上传头像图片只能是 JPG/PNG/GIF 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }

      return isImg && isLt2M;
    },
  },
};
</script>

<style lang="less">
.slider-posterActivitiesManage {
  .slider-cont .el-tabs__nav {
    padding: 0px;
  }
}
#app .posterActivitiesManage .silder-contain-creat,
#app .posterActivitiesManage .silder-contain-edit {
  .slider-cont {
    padding: 20px;
    .el-form {
      padding: 0px;
      .uplode-div .avatar-uploader .el-upload {
        width: 400px;
      }
      // 海报模板
      .poster-temp {
        margin-bottom: 10px !important;
        .el-radio-group {
          display: flex;
          flex-wrap: wrap;
          .el-radio-button {
            display: block;
            margin-right: 10px;
            margin-bottom: 10px;
            .el-radio-button__inner {
              width: 77px;
              height: 100px;
              overflow: hidden;
              padding: 0;
              img {
                width: 100%;
              }
            }
          }
        }
      }
    }
    .el-tabs__nav-scroll {
      border-bottom: 0px;
      margin-bottom: 10px;
    }
    .active-time {
      .el-form-item {
        display: inline-block;
        .el-input--medium .el-input__inner {
          padding-left: 30px;
          padding-right: 20px;
        }
      }
      .activity_endtime .el-form-item__content {
        margin-left: 0px !important;
      }
      > span {
        display: inline-block;
        margin: 0 10px;
      }
    }
    // 默认单选按钮样式
    .isdefault {
      margin-left: 10px;
      .el-radio__inner {
        width: 18px;
        height: 18px;
        border: 1px solid #20a8d8;
      }
      .el-radio__input.is-checked .el-radio__inner {
        width: 18px;
        height: 18px;
        background: #fff;
      }
      .el-radio__inner::after {
        background: #20a8d8;
        width: 6px;
        height: 6px;
      }
      .el-radio__original {
        width: 18px;
        height: 18px;
      }
    }
    .tip-text {
      display: inline-block;
      margin: 0 13px;
      color: #d0021b;
      i {
        display: inline-block;
        width: 20px;
        height: 20px;
        margin-right: 10px;
        background: rgba(210, 11, 36, 1);
        border-radius: 50%;
        font-style: normal;
        color: #fff;
        text-align: center;
        line-height: 20px;
      }
    }
    .uplode-div {
      display: inline-block;
    }
    .el-form .el-form-item__error {
      position: absolute !important;
    }
    .el-form .el-form-item {
      margin-bottom: 20px;
    }
    .upload-share {
      .avatar-share-img {
        .el-upload {
          width: 150px;
          height: 150px;
          background: #f2f2f5;
          border-radius: 8px;
          opacity: 0.9646;
          border: 1px solid #dddddd;
          .share-text {
            padding-top: 22%;
            color: #55606e;
            .el-icon-plus:before {
              font-size: 20px;
            }
          }
        }
      }
    }
  }
}
</style>
